/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR,
  AUTH_CHECK,
  AUTH_GET_PERMISSIONS,
} from 'react-admin';

import AuthService from './auth-service';

function logout() {
  // I remove logout from AUTH_LOGOUT because after two fails of AUTH_CHECK
  // there is an auto AUTH_LOGOUT and so we lost some errors because AUTH_LOGOUT call a redirect
  return Promise.resolve();
  // return new Promise((resolve) => AuthService.logout().then(resolve()));
}

/**
 * @param {string} type Request type, e.g GET_LIST
 * @param {string} resource Resource name, e.g. "posts"
 * @param {Object} payload Request parameters. Depends on the request type
 * @returns {Promise} the Promise for response
 */
export default async (type, params) => {
  if (type === AUTH_LOGIN) {
    await AuthService.restoreSession();
    return AuthService.isUser();
  } else if (type === AUTH_LOGOUT) {
    return logout();
  } else if (type === AUTH_CHECK) {
    return AuthService.isAuthenticated();
  } else if (type === AUTH_ERROR) {
    const { status } = params;
    if (status === 401 || status === 403) {
      return logout();
    }
    return Promise.resolve();
  } else if (type === AUTH_GET_PERMISSIONS) {
    await AuthService.restoreSession();
    return Promise.resolve({
      isUser: AuthService.isUser(),
      isAdmin: AuthService.isAdmin(),
    });
  }

  return Promise.reject('Unknown auth method');
};
